import { RELATIONSHIP, GENDER, RECEIPT_PREF, DISASTER_ENUM } from './enum';

const RELATIONSHIP_OPTIONS = [
    'Child',
    'Conservator',
    "Doctor's Office",
    'Employee',
    'Friend',
    'Caregiver',
    'Health Plan',
    'Medical Group',
    'Member',
    'Neighbor',
    'N/A',
    'Sales Rep',
    'Parent',
    'Power of Attorney',
    'Relative',
    'Spouse',
    'Specialist',
    'Other',
];
const RELATIONSHIP_MAP = {
    Child: RELATIONSHIP.CHILD,
    Conservator: RELATIONSHIP.CONSERVATOR,
    "Doctor's Office": RELATIONSHIP.DOCTORSOFFICE,
    Employee: RELATIONSHIP.EMPLOYEE,
    Friend: RELATIONSHIP.FRIEND,
    Caregiver: RELATIONSHIP.CAREGIVER,
    'Health Plan': RELATIONSHIP.HEALTHPLAN,
    'Medical Group': RELATIONSHIP.MEDICALGROUP,
    Member: RELATIONSHIP.MEMBER,
    Neighbor: RELATIONSHIP.NEIGHBOR,
    'N/A': RELATIONSHIP.NOTAPPLICABLE,
    'Sales Rep': RELATIONSHIP.SALESREP,
    Parent: RELATIONSHIP.PARENT,
    'Power of Attorney': RELATIONSHIP.POWEROFATTORNEY,
    Relative: RELATIONSHIP.RELATIVE,
    Spouse: RELATIONSHIP.SPOUSE,
    Specialist: RELATIONSHIP.SPECIALIST,
    Other: RELATIONSHIP.OTHER,
};
const GENDER_MAP = {
    Male: GENDER.MALE,
    Female: GENDER.FEMALE,
    'I use a different term': GENDER.UNKNOWN,
    'Non Binary': GENDER.NONBINARY,
    'I choose not to answer': GENDER.NONE,
};
const INTIAL_CONTACT_OPTIONS = [
    { label: 'Community Event', value: '1' },
    { label: 'Phone', value: '2' },
    { label: 'Referral', value: '3' },
    { label: 'Email', value: '4' },
    { label: 'Same Day Appointment', value: '5' },
    { label: 'Walk in', value: '6' },
];
const LANGUAGE_OPTIONS = [
    'English',
    'Spanish',
    'Armenian',
    'Arabic',
    'Chinese',
    'Cambodian',
    'Cantonese',
    'Dutch',
    'French',
    'Greek',
    'Hindi',
    'Italian',
    'Japanese',
    'Korean',
    'Mandarin',
    'Portuguese',
    'Russian',
    'Samoan',
    'Tagalog',
    'Vietnamese',
    'Other',
];

const GENDER_OPTIONS = [
    { label: 'Male', value: GENDER.MALE },
    { label: 'Female', value: GENDER.FEMALE },
];
const RACE_OPTIONS = [
    { label: 'I choose not to answer', value: 999 },
];
const ETHNICITY_OPTIONS = [
    { label: 'I choose not to answer', value: 'NR' },
];

const PAYMENT_OPTIONS = [
    { label: 'Get a Bill', value: '1', salesForceMatch: 'Get a Bill' },
    {
        label: 'Automatic deduction from your monthly Social Security or Railroad Retirement Board (RRB) benefit check. (The Social Security/RRB deduction may take two or more months to begin after Social Security or RRB approves the deduction. In most cases, if Social Security or RRB accepts your request for automatic deduction, the first deduction from your Social Security or RRB benefit check will include all premiums due from your enrollment effective date up to the point withholding begins. If Social Security or RRB does not approve your request for automatic deduction, we will send you a paper bill for your monthly premiums.)',
        value: '2',
        salesForceMatch: 'Auto deduction from social security',
    },
];
const MATERIALS_FOR_PRINTED_COPY = [
    {
        label: 'Part C Explanation of Benefits (EOB)',
        name: 'enrollment.page4.sub2.receiveByMailEOBPartC',
    },
    {
        label: 'Part D Explanation of Benefits (EOB).',
        name: 'enrollment.page4.sub2.receiveByMailEOBPartD',
    },
    {
        label: 'Annual Notice of Change (ANOC)',
        name: 'enrollment.page4.sub2.receiveByMailANOC',
    },
];

const ACCESSIBLE_FORMATS = [
    { label: 'Large Print', value: RECEIPT_PREF.LARGE_PRINT },
    { label: 'Braille', value: RECEIPT_PREF.BRAILLE },
    { label: 'Audio Files', value: RECEIPT_PREF.AUDIO_CD },
];
const INTERACTION_TYPES = {
    PHONE: 'By Phone',
    PERSON: 'In Person',
    EMAIL: 'By Email',
    TEXT_SMS: 'By Text/SMS',
};
const DISASTER_TYPES = [
    { label: 'Drought', value: DISASTER_ENUM.DROUGHT },
    { label: 'Flood', value: DISASTER_ENUM.FLOOD },
    { label: 'Fire', value: DISASTER_ENUM.FIRE },
    { label: 'Other', value: DISASTER_ENUM.OTHER },
];
export {
    RELATIONSHIP_OPTIONS,
    RELATIONSHIP_MAP,
    GENDER_MAP,
    INTIAL_CONTACT_OPTIONS,
    LANGUAGE_OPTIONS,
    GENDER_OPTIONS,
    RACE_OPTIONS,
    ETHNICITY_OPTIONS,
    PAYMENT_OPTIONS,
    MATERIALS_FOR_PRINTED_COPY,
    ACCESSIBLE_FORMATS,
    INTERACTION_TYPES,
    DISASTER_TYPES,
};
